import ClaimsContainer from 'Pages/Claims/ClaimsContainter';

export default ClaimsContainer;
